import React from "react";
import { styled } from "@mui/material/styles";
import {
    Button,
    Grid,
    GridProps,
    InternalStandardProps,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PaymentMethod } from "./PaymentMethodRadio";
import { useSnackbar } from "JS/Helpers/Snackbar";

const Root = styled(Grid)(({ theme }) => ({
    height: "80px",
    marginBottom: theme.spacing(8),
}));

const ButtonWrapper = styled(Grid)(({ theme }) => ({
    display: "flex",
    margin: theme.spacing(1),
}));

const BtnQuantity = styled(Button)(({ theme }) => ({
    minWidth: "60px",
    maxWidth: "40px",
    margin: theme.spacing(1),
    borderColor: theme.palette.grey[800],
    color: `${theme.palette.grey[800]} !important`,
    fontSize: theme.spacing(3),
    maxHeight: "60px",
    height: theme.spacing(12),
    "&:hover": {
        borderColor: theme.palette.grey[800],
    },
    "&:active": {
        borderColor: theme.palette.grey[800],
    },
}));

const BtnQuantityText = styled(Button)(({ theme }) => ({
    minWidth: "60px",
    maxWidth: "60px",
    margin: theme.spacing(1),
    borderColor: theme.palette.grey[800],
    color:
        theme.palette.mode === "light"
            ? `${theme.palette.grey[800]} !important`
            : `${theme.palette.grey[100]} !important`,
    fontSize: theme.spacing(3),
    backgroundColor:
        theme.palette.mode === "light"
            ? theme.palette.grey[200]
            : theme.palette.grey[900],
    maxHeight: "60px",
    height: theme.spacing(12),
    "&.Mui-disabled": {
        color:
            theme.palette.mode === "light"
                ? `${theme.palette.grey[800]} !important`
                : `${theme.palette.grey[100]} !important`,
    },
}));

export interface GiftQuantityProps extends InternalStandardProps<GridProps> {
    activeGiftItem: {
        title: string;
        giftPurchasedEnabled: boolean;
        quantity: number;
    };
    method: PaymentMethod;
    credits: number;
    onQuantityChange?: (
        event: React.MouseEvent<HTMLButtonElement>,
        action: string,
    ) => void;
    isInsufficeintCredits: boolean;
}

export const GiftQuantity = (props: GiftQuantityProps) => {
    const { enqueueSnackbar } = useSnackbar();

    const {
        className,
        activeGiftItem,
        method,
        credits,
        onQuantityChange,
        isInsufficeintCredits,
        ...rest
    } = props;

    return (
        <Root container {...rest} className={className}>
            <ButtonWrapper item={true} xs={12} md={12}>
                <BtnQuantityText
                    variant="outlined"
                    disabled
                    size="large"
                >
                    {activeGiftItem.quantity}
                </BtnQuantityText>

                <BtnQuantity
                    variant="outlined"
                    onClick={(e) => {
                        if (isInsufficeintCredits) {
                            enqueueSnackbar("Insufficient credits", {
                                variant: "warning",
                            });
                        } else {
                            onQuantityChange(e, "INCREMENT");
                        }
                    }}
                    size="large"
                >
                    <FontAwesomeIcon icon={["fas", "plus"]} />
                </BtnQuantity>

                <BtnQuantity
                    variant="outlined"
                    onClick={(e) => onQuantityChange(e, "DECREMENT")}
                    size="large"
                >
                    <FontAwesomeIcon icon={["fas", "minus"]} />
                </BtnQuantity>
            </ButtonWrapper>
        </Root>
    );
};
